import {NavGroupProps} from '@minimal/components/nav-section';
import {menu as BdeseMenu} from '@workspaces/bdese';
import {menu as GlobalMenu} from '@workspaces/global';
import {menu as NemesisMenu} from '@workspaces/nemesis';
import {menu as PilotageMenu} from '@workspaces/pilotage-rh';
import {WorkspaceList} from '@workspaces/workspaces';

export const menus: Record<WorkspaceList, NavGroupProps[]> = {
  [WorkspaceList.BDESE]: BdeseMenu,
  [WorkspaceList.GLOBAL]: GlobalMenu,
  [WorkspaceList.NEMESIS]: NemesisMenu,
  [WorkspaceList.PILOTAGE_RH]: PilotageMenu,
};
